export default {
    data() {
        return {
            mt: {},
            isNeed: '需要',
            hhhhhhlll: false,
            isele: '电子版',
            tishilll: '',
            invoice_title: '',
            tax_no: '',
            Mail_box: '',
            Mailing_address: '',
            productArr: [],
            boughtFlag: '',
            boughtProducts: [],
            commodityList: [
                // {
                //     id: '1',
                //     image: require('../../assets/images/avatar.jpg'),
                //     name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tat.',
                //     price: '344'
                // }
            ],
            totalprices: 0
        }
    },
    methods: {
        // submitOrder(){
        //     window.onload = function () {
        //         window.onscroll = function () {
        //             let scrollTop = document.body.scrollTop ? document.body.scrollTop : document.documentElement.scrollTop;
        //             if (scrollTop >= 300) {
        //                 document.querySelector('#submitOrder').style.cssText =" width:100%";
        //             } else {
        //                 document.querySelector('#submitOrder').style.cssText = 'position:fixed; bottom:0; width:100% ;';
        //             }
        //         }
        //     }
        // },

        //立即下单
        payMoney: function () {
            //如果是不允许有发票的版本
            if (this.$store.state.store.is_invoice == '0') {
                this.isNeed = '不需要'
            }

            let mt = this.mt;
            let arr = this.$route.query.commodityList;
            let parseArr = '';
            if (!this.boughtFlag) {
                UIkit.modal(document.querySelector('#modal-already-bought')).show();
                return;
            }
            if (this.isNeed == '需要') {
                if (this.tax_no == '') {
                    this.tishilll = '税号不能为空'
                    UIkit.modal(mt).show();
                    return false;
                }
                if (this.invoice_title == '') {
                    this.tishilll = '发票抬头不能为空'
                    UIkit.modal(mt).show();
                    return false;
                }
                if (this.Mail_box == '' && this.Mailing_address == '') {
                    this.tishilll = '电子邮箱/邮寄地址不能为空'
                    UIkit.modal(mt).show();
                    return false;
                }

            }
            if (this.isNeed == '不需要') {
                this.isele = '';
            }
            if (this.$route.query.shopId) {
                parseArr = JSON.parse(this.$route.query.shopId);
            }
            this.$post('orders/create', {
                pay_type: 1,
                token: this.$store.state.id,
                invoice_title: this.invoice_title,
                tax_no: this.tax_no,
                invoice_type: this.isele,
                invoice_email: this.Mail_box,
                invoice_address: this.Mailing_address,
                products: arr,
                shop_id: this.$store.state.store.id
            }).then(res => {
                let me = this;
                if (res.data.status === 'success') {
                    if (this.$route.query.shopId) {
                        for (let val of parseArr) {
                            (function () {
                                me.$post('shopping_cart/delete', { token: me.$store.state.id, id: Number.parseFloat(val) }).then(res => {
                                    me.$post('shopping_cart/search', { token: me.$store.state.id, offset: '0', length: 9999,shop_id:me.$store.state.store.id }).then(res => {
                                        me.$store.state.shopNum = res.data.result.data.length;
                                    });
                                })
                            })(val)
                        }
                    }
                    return res.data;
                } else {
                    return res.data;
                }
            }).then(data => {
                // // console.log(data);
                if (data.errorMsg) {
                    if (data.errorMsg[0] == 'The invoice email must be a valid email address.') {
                        UIkit.modal(document.querySelector('#modal-email-error')).show();
                        return;
                    }
                }

                //如果是不允许有发票的版本
                // if (this.$store.state.store.is_invoice == '1') {
                //     this.tishilll = '发票信息填写后，需致电客服热线确认发票信息，4008-032-321'
                //     UIkit.modal(mt).show();
                // }
                this.$post('orders/get', { id: data.result, token: this.$store.state.id }).then(res => {
                    this.$router.push({
                        path: '/paycenter',
                        query: {
                            order_id: data.result,
                            commodityList: this.productArr,
                            code: res.data.result.code,
                        }
                    })
                })
            })
        },
        homePage: function () {
            this.$router.push({
                path: '/'
            })
        },
        //跳转商品详细页面
        commodityDetails: function (id) {
            this.$router.push({
                path: '/classdetails',
                query: {
                    id: id
                }
            });
        },
        //根据传来的id查找
        getGoods: function () {
            let arr = JSON.parse(this.$route.query.commodityList);
            this.productArr = this.$route.query.commodityList;
            for (let id of arr) {
                this.$post('products/get', { id: id }).then(res => {
                    res.data.result.id = id;
                    this.commodityList.push(res.data.result);

                    this.totalprices += Number.parseFloat(res.data.result.price);
                });
            }
        },
        //判断商品是否已经购买过了
        isBought: function () {
            let arr = JSON.parse(this.$route.query.commodityList);
            for (let i = 0; i < arr.length; i++) {
                this.$post('users/isPay', { product_id: Number.parseFloat(arr[i]), token: this.$store.state.id }).then(res => {
                    if (res.data.result != true) {
                        this.boughtFlag = false;
                        this.payMoney();
                        return;
                    } else if (i == arr.length - 1) {
                        this.boughtFlag = true;
                        this.payMoney();
                        return;
                    }
                })
            }
        }
    },

    created() {
        this.getGoods();
    },
    mounted: function () {
        this.mt = document.querySelector('#modal-tishilll');
        document.title = '立即下单';
    },
}

